import script from "./rank.vue?vue&type=script&setup=true&lang=js"
export * from "./rank.vue?vue&type=script&setup=true&lang=js"

import "./rank.vue?vue&type=style&index=0&id=7396aab7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7396aab7"]])

export default __exports__